import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const i18n  = new VueI18n({
	locale: 'en',
	messages: {
		'en': require('Translations/translations.en.json'),
		'ru': require('Translations/translations.ru.json')
	},
	silentTranslationWarn: true
});

if (module.hot) {
	module.hot.accept(['Translations/translations.en', 'Translations/translations.ru'], function () {
		i18n.setLocaleMessage('en', require('Translations/translations.ru'))
		i18n.setLocaleMessage('ru', require('Translations/translations.ru'))
		// Or the following hot updates via $i18n property
		// app.$i18n.setLocaleMessage('en', require('./en').default)
		// app.$i18n.setLocaleMessage('ja', require('./ja').default)
	})
}

export default i18n;